import React, {Component} from "react";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import {connect} from "react-redux";

import {ActionCreator} from "../../../../../../../actions/actions";
import {hallsStoreSelectors} from "../../../../../store/store";
import {HallsActionCreators} from "../../../../../actions/actionCreators";
import {ServerLicense} from "../../../../../reducers/licenses.reducer";

import "./LicenseAwaitLicense.component.scss";
import {Dialog} from "../../../../../../../utils/Dialog/Dialog.component";
import {checkPermission} from "../../../../../../../utils/Authorization/authorization";


export interface LicenseAwaitLicenseProps {
    serverId: number;
    cancelLicenseProcess: ActionCreator;
    updateLicenseDuration: ActionCreator;
    getServerLicense: ActionCreator;
    getLicenseDownload: ActionCreator;
    setLicenseApplied: ActionCreator;
    serverLicenseLoading: boolean;
    serverLicense: ServerLicense;
    serverName: string;
    serverDurationSet: boolean;
    clearUpdateDuration: ActionCreator;
    allow: boolean;
}

export interface LicenseAwaitLicenseState {
    duration: number;
    confirmCancel: boolean;
}

class LicenseAwaitLicense extends Component<
    LicenseAwaitLicenseProps,
    LicenseAwaitLicenseState
> {
    constructor(props) {
        super(props);

        this.state = {
            duration: 180,
            confirmCancel: false
        };

        this.props.clearUpdateDuration();
    }

    componentDidMount() {
        this.props.getServerLicense({
            serverId: this.props.serverId
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.serverLicense != this.props.serverLicense &&
            this.props.serverLicense &&
            this.props.serverLicense.duration &&
            !this.props.serverLicense.expired &&
            this.state.duration != this.props.serverLicense.duration
        ) {
            this.setState({
                duration: this.props.serverLicense.duration
            });
        }
    }

    changeDuration = e => {
        this.setState({
            duration: e.target.value != "" ? e.target.value : undefined
        });
    };

    updateDuration = () => {
        if (!this.state.duration || this.state.duration > 180 || this.state.duration <= 0)
            console.log('Invalid duration!')
        else this.props.updateLicenseDuration({
            serverId: this.props.serverId,
            duration: this.state.duration
        });
    };

    render() {
        if (this.props.serverLicenseLoading) {
            return (
                <div className="loading">
                    <Components.LoadingRipple height={100} width={100}/>
                </div>
            );
        }

        return (
            <div id="LicenseAwaitLicense">
                <div className="row">
                    {checkPermission('manage_licensing') && (
                        <div className="col-6">
                            <h2>Set License duration</h2>
                            <p>
                                Set a new duration for the license or confirm the
                                default value.
                            </p>
                            {this.props.serverLicense &&
                                this.props.serverDurationSet && (
                                    <span className="current-days">
                                    Currently set for{" "}
                                        <b>
                                        {this.props.serverLicense != null &&
                                        !this.props.serverLicense.expired &&
                                        this.props.serverLicense.duration
                                            ? this.props.serverLicense.duration.toString()
                                            : this.state.duration.toString()}{" "}
                                            days
                                    </b>
                                </span>
                                )}
                            <div className="row duration-form">
                                <input
                                    key={180}
                                    type="number"
                                    className={`input ${!(this.state.duration <= 180 && this.state.duration > 0) && "input-error"
                                    }`}
                                    placeholder="Duration (days)"
                                    onChange={this.changeDuration}
                                    defaultValue={
                                        this.props.serverLicense != null &&
                                        !this.props.serverLicense.expired &&
                                        this.props.serverLicense.duration
                                            ? this.props.serverLicense.duration.toString()
                                            : this.state.duration != null &&
                                            this.state.duration != undefined
                                                ? this.state.duration.toString()
                                                : ""
                                    }
                                />
                                <button
                                    className="red-btn confirm-btn"
                                    onClick={this.updateDuration}
                                    disabled={
                                        !this.state.duration ||
                                        this.state.duration > 180 ||
                                        this.state.duration <= 0
                                    }
                                >
                                    Set Duration
                                </button>
                            </div>
                            {
                                !(this.state.duration <= 180 &&
                                    this.state.duration > 0) &&
                                (<div className="input-error">
                                <span className="input-error-message">
                                    {'Must be > than 0 and <= than 180.'}
                                </span>
                                </div>)
                            }
                        </div>
                    )}
                    {this.props.serverLicense && checkPermission('download_license') &&
                        <div className="col-6 license-download-panel">
                            <h2>Download License</h2>
                            <p>
                                The license duration is
                                {(this.props.serverLicense.duration == 180) &&
                                    " 180 days by default."}
                                {this.props.serverLicense.duration != 180 &&
                                    ` set to ${this.props.serverLicense.duration} days.`}{" "}
                                To change this duration set it's new value before
                                downloading.
                            </p>
                            <button
                                className="red-btn download-btn"
                                onClick={() => {
                                    this.props.getLicenseDownload({
                                        serverId: this.props.serverId,
                                        serverName: this.props.serverName
                                    });
                                }}
                            >
                                <i className="icon-file-archive-light"/>
                                Download License
                            </button>
                            {!this.props.serverDurationSet &&
                                this.props.serverLicense &&
                                this.props.serverLicense.expired && (
                                    <div className="blocked-license">
                                        <p>
                                            The current license is expired or
                                            invalidated. Please set a license duration
                                            before continue.
                                        </p>
                                    </div>
                                )}
                        </div>
                    }
                </div>
                {checkPermission('manage_licensing') && (
                    <div>
                        <div className="input-and-button">
                            {this.props.allow && (
                                <div>
                                    <button
                                        className="btn cancel-btn"
                                        onClick={() => {
                                            this.setState({
                                                confirmCancel: true
                                            });
                                        }}
                                    >
                                        Restart Process
                                    </button>
                                </div>
                            )}
                            <div>
                                <button
                                    className="red-btn confirm-btn"
                                    disabled={
                                        this.props.serverLicense
                                            ? this.props.serverLicense.expiration ==
                                            undefined ||
                                            this.props.serverLicense.expired
                                            : true
                                    }
                                    onClick={() => {
                                        this.props.setLicenseApplied({
                                            serverId: this.props.serverId
                                        });
                                    }}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <Dialog
                    open={this.state.confirmCancel}
                    onConfirm={() => {
                        this.props.cancelLicenseProcess({
                            serverId: this.props.serverId
                        });
                    }}
                    onClose={() => {
                        this.setState({
                            confirmCancel: false
                        });
                    }}
                >
                    <p>
                        <b>ATTENTION</b>
                    </p>
                    <span>
                        Canceling this license will{" "}
                        <b>require a new seed upload</b>. Proceed with caution
                        and verify if a seed file exists or can be downloaded
                        from the server.
                    </span>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    serverLicense: hallsStoreSelectors.serverLicense(state),
    serverLicenseLoading: hallsStoreSelectors.serverLicenseLoading(state),
    serverDurationSet: hallsStoreSelectors.serverDurationSet(state)
});

const mapDispatchToProps = {
    cancelLicenseProcess: HallsActionCreators.cancelLicenseProcess,
    updateLicenseDuration: HallsActionCreators.updateLicenseDuration,
    getServerLicense: HallsActionCreators.getServerLicense,
    getLicenseDownload: HallsActionCreators.getLicenseDownload,
    setLicenseApplied: HallsActionCreators.setLicenseApplied,
    clearUpdateDuration: HallsActionCreators.clearUpdateDuration
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LicenseAwaitLicense);
